export enum StrategyDisplayStateEnum {
    Empty = 'Empty',
    Generating = 'Generating',
    Loading = 'Loading',
    Ready = 'Ready',
}

export const SNAPSHOT_SECTION_ID = 's1';
export const DISCOVERY_PAIN_POINTS_CONTAINER_ID = 's5';
export const DISCOVERY_QUESTIONS_SECTION_ID = 's5a';
export const PAIN_POINTS_SECTION_ID = 's5b';
export const CONTACT_INFO_SECTION_ID = 's7';
export const REFERENCES_SECTION_ID = 's8';

export const FULL_WIDTH_SECTION_IDS: string[] = [
    SNAPSHOT_SECTION_ID,
    CONTACT_INFO_SECTION_ID,
    REFERENCES_SECTION_ID,
];

export const SSB_TITLE = 'Sales Strategy Builder';
export const SSB_BETA_LABEL = 'BETA';
export const SSB_GENERATING_TEXT = 'Building your sales strategy, this may take a few minutes...';
export const SSB_ALMOST_THERE_TEXT = 'Almost there, finishing the rest of your strategy...';
export const SSB_RESTART = 'RESTART';
export const SSB_VIEW_STRATEGY = 'View Strategy';
export const SSB_HIDE_STRATEGY = 'Hide Strategy';

export const SSB_GET_STARTED_FORM_TITLE = 'Build a sales strategy based on your company.';
export const SSB_GET_STARTED_FORM_SUBTITLE = 'For a more tailored result, include details about what you’re trying to sell.';
export const SSB_GET_STARTED_FORM_PLACEHOLDER = 'Enter some details on what you are selling, like the specific product or brand';
export const SSB_BUILD_MY_STRATEGY = 'build my strategy';

export const SSB_COPY_ARIA = 'Copy sales strategy';
export const SSB_COPY_SUCCESS = 'Strategy copied to clipboard';
export const SSB_COPY_ERROR = 'Could not copy the strategy';
export const SSB_SELLING_FOCUS_TITLE = 'Your Selling Focus';

export const SSB_INFO_ARIA = 'About the Sales Strategy Builder';
export const SSB_INFO_INTRO = 'Generate a sales playbook personalized at the:';
export const SSB_INFO_LEVELS = [
    'Operator level (this profile)',
    'Account level (your company)',
    'User level (optional, based on your input)',
];
export const SSB_GENERATED_ON_PREFIX = 'generated on';
export const SSB_GENERATED_ON_DATE_FORMAT = 'MMM D, YYYY';

export const SSB_INPUT_MAX_LENGTH = 200;
export const SSB_INPUT_LIMIT_MESSAGE = 'You have reached the 200 character limit.';
export const SSB_TRIGGER_ERROR = 'Request failed. Please try again.';
export const SSB_POLL_ERROR = 'Connection lost. Please reload the page.';
export const SSB_TIMEOUT_ERROR = 'Strategy generation timed out. Please try again.';
export const SSB_POLL_INTERVAL_MS = 5000;
export const SSB_POLL_MAX_ATTEMPTS = 60;
